



export const TRICKSTRAT_LOADING = {
  0:'Loading...',
};



export const GEARS4_LOADING = {
  0:'Active Reloading...',
  1:'Triple capping...',
  2:'OEing to their home...',
};



// WEBPACK FOOTER //
// ./src/app/utils/loading/loadingArrays.js